document.addEventListener('DOMContentLoaded', function() {
  // Menu toggle
  var menuTrigger = document.querySelector('.menu-trigger');
  if (menuTrigger) {
    menuTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('show-menu');
    });
  }

  var mainOverlay = document.querySelector('.main-overlay');
  if (mainOverlay) {
    mainOverlay.addEventListener('click', function() {
      document.body.classList.remove('show-menu');
      document.body.classList.remove('show-index');
    });
  }

  // Credits toggle
  var toggleCredits = document.querySelectorAll('.toggle-credits');
  if (toggleCredits) {
    toggleCredits.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('#footer').classList.toggle('show-credits');
      });
    });
  }

  // Page transition
  $("a:not([target='_blank']):not(.cart-trigger)").on("click", function (e) {
    const url = $(this).attr("href");

    if (url && url.indexOf("#") !== 0) {
      e.preventDefault();
      $("body").addClass("fade-out");
      setTimeout(function () {
        window.location.href = url;
      }, 300);
    }
  });
  
  window.addEventListener("pageshow", function() {
    $("body").removeClass("fade-out");
  }, false);
  
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // Index toggle: hover trigger on desktop (≥821px), click on mobile
  const indexTrigger = document.getElementById('product-index-trigger');
  const productIndexContainer = document.querySelector('#product-index-container');
  if (indexTrigger && productIndexContainer) {
    var indexDesktopHover = window.matchMedia('(min-width: 821px)');

    indexTrigger.addEventListener('mouseenter', function() {
      if (indexDesktopHover.matches) document.body.classList.add('show-index');
    });
    productIndexContainer.addEventListener('mouseleave', function() {
      if (indexDesktopHover.matches) document.body.classList.remove('show-index');
    });

    indexTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (indexDesktopHover.matches) return;
      document.body.classList.toggle('show-index');
    });
  }

  // Outerworld filter toggle: hover trigger on desktop (≥821px), click on mobile
  var outerworldFilterTrigger = document.getElementById('filters-trigger');
  var filtersContainer = document.querySelector('#filters-container');
  if (outerworldFilterTrigger && filtersContainer) {
    var desktopHover = window.matchMedia('(min-width: 821px)');

    outerworldFilterTrigger.addEventListener('mouseenter', function() {
      if (desktopHover.matches) filtersContainer.classList.add('show');
    });
    filtersContainer.addEventListener('mouseleave', function() {
      if (desktopHover.matches) filtersContainer.classList.remove('show');
    });

    outerworldFilterTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (desktopHover.matches) return;
      filtersContainer.classList.toggle('show');
    });
  }

  // Innerworld filter toggle
  var innerworldFilterTrigger = document.getElementById('emotions-trigger');
  if (innerworldFilterTrigger) {
    innerworldFilterTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('#innerworld-filters-emotions').classList.toggle('show');
    });
  }

  // Hover menu
  var hoverContainer = document.getElementById('hover-image-container');
  var navLinks = document.querySelectorAll('.nav-link[data-hover]');
  
  navLinks.forEach(function(link) {
    var hoverSrc = link.getAttribute('data-hover');
    var hoverType = link.getAttribute('data-type');
    
    if (hoverSrc && hoverSrc !== '') {
      link.addEventListener('mouseenter', function() {
        if (hoverContainer) {
          // Remove any existing hover media
          var existingMedia = hoverContainer.querySelector('.nav-hover-image, .nav-hover-video');
          if (existingMedia) {
            existingMedia.remove();
          }
          
          // Create and append new hover media
          var mediaElement;
          if (hoverType === 'video') {
            mediaElement = document.createElement('video');
            mediaElement.src = hoverSrc;
            mediaElement.className = 'nav-hover-image';
            mediaElement.autoplay = true;
            mediaElement.loop = true;
            mediaElement.muted = true;
            mediaElement.playsInline = true;
          } else {
            mediaElement = document.createElement('img');
            mediaElement.src = hoverSrc;
            mediaElement.className = 'nav-hover-image';
          }
          
          hoverContainer.appendChild(mediaElement);
          
          // Add show class to container
          hoverContainer.classList.add('show');
        }
      });
      
      link.addEventListener('mouseleave', function() {
        if (hoverContainer) {
          var media = hoverContainer.querySelector('.nav-hover-image, .nav-hover-video');
          if (media) {
            // Pause video if it exists
            if (media.tagName === 'VIDEO') {
              media.pause();
            }
            // media.remove();
          }
          
          // Remove show class from container
          hoverContainer.classList.remove('show');
        }
      });
    }
  });

  // Footer height
  function setFooterHeightVar() {
    var footer = document.getElementById('footer');
    if (footer) {
      var height = footer.offsetHeight;
      document.documentElement.style.setProperty('--footer-height', height + 'px');
    }
  }
  setFooterHeightVar();
  window.addEventListener('resize', setFooterHeightVar);

  // Newsletter form - show submit button when email field has content
  $('.mc-embedded-subscribe-form #mce-EMAIL').on('input', function() {
    var $form = $(this).closest('.mc-embedded-subscribe-form');
    if ($(this).val().trim().length > 0) {
      $form.addClass('show-submit');
    } else {
      $form.removeClass('show-submit');
    }
  });

  // Newsletter form
  $('.mc-embedded-subscribe-form').submit(function(e) {
    e.preventDefault();
    var $form = $(this);
    var url = $form.attr('action').replace('/post?', '/post-json?') + '&c=?';
    $.ajax({
      type: 'GET',
      url: url,
      data: $form.serialize(),
      cache: false,
      dataType: 'jsonp',
      jsonp: 'c',
      contentType: 'application/json; charset=utf-8',
      success: function(data) {
        if (data.result === 'success') {
          $('.mce-success-response').html(data.msg).show();
          $('.mce-error-response').hide();
          $('#footer-nav').addClass('show-response');
          $form[0].reset();
        } else {
          $('.mce-error-response').html(data.msg).show();
          $('.mce-success-response').hide();
          $('#footer-nav').addClass('show-response');
        }
        setTimeout(function() {
          $('.response').hide();
          $('#footer-nav').removeClass('show-response');
        }, 3000);
      }
    });
  });
});
